var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "add-order-comment-form"
  }, [_c('BForm', [_c('BTextarea', {
    staticClass: "mb-1",
    staticStyle: {
      "min-height": "187px"
    },
    attrs: {
      "readonly": _vm.isSaving['salesOrderComment'] || !_vm.hasPermission('orders.addcomment'),
      "placeholder": "Voeg een notitie toe...",
      "spellcheck": "false",
      "size": "xl"
    },
    model: {
      value: _vm.salesOrderComment,
      callback: function ($$v) {
        _vm.salesOrderComment = $$v;
      },
      expression: "salesOrderComment"
    }
  })], 1), _c('OmniButtonCollection', {
    staticClass: "mt-4",
    attrs: {
      "alignment": "end"
    }
  }, [_c('OmniButton', {
    attrs: {
      "disabled": _vm.cancelButtonDisabled,
      "icon": "times",
      "size": "lg",
      "variant": "danger"
    },
    on: {
      "click": _vm.cancelEditComment
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.cancel')) + " ")]), _c('OmniButton', {
    attrs: {
      "disabled": _vm.saveButtonDisabled,
      "isProcessing": _vm.isSaving['salesOrderComment'],
      "icon": "save",
      "size": "lg",
      "variant": "success"
    },
    on: {
      "click": _vm.saveComment
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }